(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.topbar = this.querySelector('.vc-header-topbar');
      this.adoptSavedBar = () => {
        if (this.getAttribute('data-vc-topbar-enabled') !== 'true') return;
        const savedBar = document.querySelector('main .vc-bar');
        if (!savedBar || !this.topbar) return;
        if (this.savedBarSection?.isConnected) this.savedBarSection.removeAttribute('data-vc-bar-moved');
        this.savedBarSection = savedBar.closest('.shopify-section');
        this.savedBarSection?.setAttribute('data-vc-bar-moved', '');
        if (this.getAttribute('data-vc-reuse-bar') === 'true') this.topbar.replaceChildren(savedBar);
        this.setHeaderHeight();
      };
      this.adoptSavedBar();
      this.barObserver = new MutationObserver(this.adoptSavedBar);
      this.barObserver.observe(document.body, { childList: true, subtree: true });
      this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.resizeObserver.observe(this.header);
      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const scrollAway = this.getAttribute('data-vc-topbar-sticky') === 'true' ? 0 : (this.topbar?.offsetHeight || 0);
      this.header.style.setProperty('--vc-header-scrollaway', `${scrollAway}px`);
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight - scrollAway}px`);
    }

    disconnectedCallback() {
      this.barObserver?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.savedBarSection?.isConnected) {
        const bar = this.topbar?.querySelector('.vc-bar');
        if (bar && this.getAttribute('data-vc-reuse-bar') === 'true') this.savedBarSection.append(bar);
        this.savedBarSection.removeAttribute('data-vc-bar-moved');
      }
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velore-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vc-gallery-video')) {
  customElements.define('vc-gallery-video', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userPaused = false;
      this.manualPlay = false;
      this.label = this.getAttribute('aria-label');
      this.reduced.addEventListener('change', () => {
        this.manualPlay = false;
        if (this.reduced.matches) this.release();
        this.sync();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.addEventListener('click', () => this.toggle(), options);
      this.addEventListener('keydown', event => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        event.preventDefault();
        this.toggle();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
        this.sync();
      }, { threshold: [0, 0.2] });
      this.observer.observe(this);
    }
    toggle() {
      if (this.video && !this.video.paused) {
        this.userPaused = true;
        this.manualPlay = false;
      } else {
        this.userPaused = false;
        this.manualPlay = true;
      }
      this.sync();
    }
    mount() {
      const template = this.querySelector('template');
      if (!template) return;
      this.querySelector('.vc-gallery-video__media').append(template.content.cloneNode(true));
      const video = this.video = this.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = !this.reduced.matches;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.tabIndex = -1;
      video.addEventListener('playing', () => {
        if (this.video === video) this.setAttribute('data-playing', '');
      }, { signal: this.abort.signal });
      video.addEventListener('error', () => {
        if (this.video !== video) return;
        this.removeAttribute('data-playing');
        this.userPaused = true;
        this.setAttribute('aria-label', `Video abspielen. ${this.label}`);
      }, { signal: this.abort.signal });
    }
    sync() {
      const play = this.visible && !document.hidden && !this.userPaused && (!this.reduced.matches || this.manualPlay);
      if (play && !this.video) this.mount();
      const video = this.video;
      if (!video) return;
      if (!play) video.pause();
      else video.play().catch(() => {
        if (this.video !== video || !this.visible || document.hidden || this.userPaused) return;
        this.userPaused = true;
        this.setAttribute('aria-label', `Video abspielen. ${this.label}`);
      });
      this.setAttribute('aria-label', `${play ? 'Video pausieren' : 'Video abspielen'}. ${this.label}`);
    }
    release() {
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.load();
      }
      this.video = null;
      this.querySelector('.vc-gallery-video__media').replaceChildren();
      this.removeAttribute('data-playing');
    }
    disconnectedCallback() {
      this.abort.abort();
      this.observer.disconnect();
      this.release();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
